import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

var getSizeInPixel = function getSizeInPixel(size, maxSize, opts) {
  var options = _objectSpread({
    units: ['%', 'em', 'rem']
  }, opts);

  var pixelSize;

  if (isNumber(size)) {
    pixelSize = size;
  } else if (isString(size)) {
    var sizeMatches = size.match(/^([-0-9.]+)(%|em|rem|px)$/i);

    if (sizeMatches) {
      var unit = sizeMatches[2].toLowerCase();
      var floatValue = parseFloat(sizeMatches[1]);
      var value = unit === 'rem' || unit === 'em' ? floatValue * 100 : floatValue;
      pixelSize = options.units.indexOf(unit) !== -1 ? value / 100 * maxSize : value;
    } else {
      pixelSize = !Number.isNaN(parseFloat(size)) ? parseFloat(size) : null;
    }
  } else {
    pixelSize = maxSize;
  }

  return pixelSize;
};

export default getSizeInPixel;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/size/es/getSizeInPixel.js
// module id = null
// module chunks = 